// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { Record, Feature } from '@fulcrumapp/fulcrum-core';
import cx from 'classnames';
import distance from '@turf/distance';
import _ from 'lodash';
import MetadataField from './metadata-field';

export default class AuditLocationField extends MetadataField {
  static propTypes = {
    ...MetadataField.propTypes,
    record: PropTypes.instanceOf(Record).isRequired,
    feature: PropTypes.instanceOf(Feature).isRequired,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    altitude: PropTypes.number,
    accuracy: PropTypes.number,
    locationTitle: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  renderEditable() {
    const { styles } = AuditLocationField;

    return (
      <div className={css(styles.container)}>
        {this.renderLocationLabel()}
      </div>
    );
  }

  renderLocationLabel() {
    const { styles } = AuditLocationField;

    const label = this.locationLabel;

    if (label && label.length) {
      return (
        <span className={styles.location}>
          {label}
          {this.renderDetails()}
        </span>
      );
    }

    return <span className={styles.noLocation}>No Location</span>;
  }

  renderDetails() {
    const { styles } = AuditLocationField;

    const details = _.compact([this.accuracyLabel, this.distanceLabel]);

    if (details.length) {
      return (
        <span className={css(styles.details)}>
          (
          {details.join(', ')}
          )
        </span>
      );
    }

    return null;
  }

  get accuracyLabel() {
    if (this.props.accuracy != null && this.props.accuracy >= 0) {
      return `${parseInt(this.props.accuracy, 10)}m accuracy`;
    }

    return null;
  }

  get altitudeLabel() {
    if (this.props.altitude != null) {
      return `${parseInt(this.props.altitude, 10)}m ${this.props.altitude >= 0 ? 'above' : 'below'} sea level`;
    }

    return null;
  }

  get distanceLabel() {
    if (!this.props.feature.hasCoordinate || this.props.latitude == null) {
      return null;
    }

    const auditPoint = {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [this.props.longitude, this.props.latitude],
      },
    };

    const recordPoint = {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [this.props.feature.longitude, this.props.feature.latitude],
      },
    };

    const units = 'kilometers';

    const dist = distance(auditPoint, recordPoint, units) * 1000;

    const distanceLabel = `${dist.toFixed(1)}m`;

    return `${distanceLabel} from the record`;
  }

  renderLabelContent() {
    return <strong className={MetadataField.styles.strong}>{this.props.locationTitle}</strong>;
  }

  renderValueContent() {
    return this.renderLocationLabel();
  }

  get locationLabel() {
    if (this.props.latitude != null && this.props.longitude != null) {
      return `${this.props.latitude.toFixed(6)}, ${this.props.longitude.toFixed(6)}`;
    }

    return null;
  }
}

const styles = cssInJS({
  container: {
    paddingTop: 10,
    paddingLeft: 4,
  },

  details: {
    color: '#888',
    marginLeft: 4,
  },

  location: {
    marginRight: 8,
  },

  noLocation: {
    color: '#888',
    fontStyle: 'italic',
    marginRight: 8,
  },
});

AuditLocationField.styles = styles;
